import React from 'react';
import TestComponent from './components/TestComponent';
// import Test from './Test';



function App() {
  return (
    <div className="App">
      {/* <Test /> */}
      <TestComponent />
    </div>
  );
}

export default App;
